import { takeLatest, put } from 'redux-saga/effects'
import request from '@/helpers/axios'
import { FIELDS_SETTINGS_ENDPOINT } from '@/constants/apiRoutes'
import {
  GET_SETTINGS_PASSPORT,
  successActiveFieldsPassport
} from '@/store/actions/passportization'

import createNotifications from '@/helpers/notification'

function* setSettingsFields() {
  try {
    const response = yield request({
      url: FIELDS_SETTINGS_ENDPOINT,
      method: 'get',
    })

    yield put(successActiveFieldsPassport(response.data))
  } catch (error) {
    const toast = createNotifications()
    toast({
      title: 'Ошибка операции!',
      description: 'Не удалось сохранить настройки паспорта.\nПовторите попытку позже.',
      type: 'error',
    })
  }
}

export default function* root() {
  yield takeLatest(GET_SETTINGS_PASSPORT, setSettingsFields)
}
